import t from "@ext/localization/locale/translate";
import { DropdownMenuItem } from "@ui-kit/Dropdown";
import { Switch } from "@ui-kit/Switch";
import { useBranchCheckoutSettingsStore } from "../logic/BranchCheckoutSettingsStore";

export const BranchCheckoutModeToggle = () => {
	const mode = useBranchCheckoutSettingsStore((state) => state.mode);
	const setMode = useBranchCheckoutSettingsStore((state) => state.setMode);
	const transferChanges = mode === "transfer";

	return (
		<DropdownMenuItem
			onClick={(event) => {
				event.preventDefault();
				event.stopPropagation();
				setMode(transferChanges ? "block" : "transfer");
			}}
		>
			<div className="flex w-full items-center justify-between gap-4">
				<span>{t("git.checkout.transfer-changes")}</span>
				<Switch
					aria-label={t("git.checkout.transfer-changes")}
					checked={transferChanges}
					onChange={(event) => {
						event.preventDefault();
						event.stopPropagation();
					}}
					onCheckedChange={(checked) => setMode(checked ? "transfer" : "block")}
					size="xs"
				/>
			</div>
		</DropdownMenuItem>
	);
};
